module.exports = __webpack_public_path__ + "img/turbo_on.938d10f2.svg";